export const onChangeLogo = (state, payload) => {
  return {
    ...state,
    logoData: {
      logoUrl: payload.fileUrl,
    }
  };
};